import React from "react"
import { EExceptionType, IShiftExceptionDocument, IPunchSetRecordDto, IPunchException, EExceptionUITypes, EExceptionReviewDialogExceptionType } from "../../models"
import { Chip } from "material-ui"
import strings from "../../localization/strings"
import { amber500, green500, grey500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
interface IProps {
  selectedFilterTypes: EExceptionUITypes[]
  exceptionItem: IPunchSetRecordDto | IShiftExceptionDocument
  handleShowExceptionDailog(exceptionType: EExceptionReviewDialogExceptionType, exceptionPunchId: string): void
}

const ExceptionsCol: React.SFC<IProps> = (props: IProps) => {
  const exceptions: string[] = []
  let unReviewedBioAndLocException: IPunchException
  let firstBioAndLocException: IPunchException
  let backgroundColor = amber500
  const exceptionItem = props.exceptionItem as IPunchSetRecordDto
  if (exceptionItem.PunchSet) {
    const exceptionPunchSet = exceptionItem.PunchSet
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.BIOMETRIC) &&
      exceptions.push(strings.Bio)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.LOCATION || item.TypeEnum === EExceptionType.MICRO_LOCATION || item.TypeEnum === EExceptionType.NO_DEVICE_LOCATION || item.TypeEnum === EExceptionType.NO_LOCATION_OR_MICROLOCATION) &&
      exceptions.push(strings.Loc)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.MISSING_PUNCH) &&
      exceptions.push(strings.Miss)
    AccountStore.getEmployeeApproveTimecardEnabled() &&
      exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.MISSING_EMPLOYEE_APPROVAL) &&
      exceptions.push(strings.Emp_Approval)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.MISSING_SUPERVISOR_APPROVAL) &&
      exceptions.push(strings.Sup_Approval)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.EARLY_IN_PUNCH) &&
      exceptions.push(strings.Early_In)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.LATE_IN_PUNCH) &&
      exceptions.push(strings.Late_In)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.EARLY_OUT_PUNCH) &&
      exceptions.push(strings.Early_Out)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.LATE_OUT_PUNCH) &&
      exceptions.push(strings.Late_Out)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.LONG_BREAK) &&
      exceptions.push(strings.Long_Break)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.NO_SHIFT) &&
      exceptions.push(strings.No_Shift)
    exceptionPunchSet.PunchExceptions.find(item => item.TypeEnum === EExceptionType.QUESTION_EXCEPTION) &&
      exceptions.push(strings.Question_Exception)

    if (exceptions.filter(item => item === strings.Bio || item === strings.Loc).length === exceptions.length) {
      let bioAndLocExceptions: IPunchException[] = []
      bioAndLocExceptions = exceptionPunchSet.PunchExceptions.filter(item =>
        item.TypeEnum === EExceptionType.BIOMETRIC ||
        item.TypeEnum === EExceptionType.LOCATION ||
        item.TypeEnum === EExceptionType.MICRO_LOCATION ||
        item.TypeEnum === EExceptionType.NO_DEVICE_LOCATION ||
        item.TypeEnum === EExceptionType.NO_LOCATION_OR_MICROLOCATION
      )
      const reviewedCount = bioAndLocExceptions.filter(item => item.Reviewed).length
      if (reviewedCount === bioAndLocExceptions.length) {
        backgroundColor = bioAndLocExceptions.find(item => item.Rejected) ? grey500 : green500
      }
    }
    unReviewedBioAndLocException = exceptionPunchSet.PunchExceptions.find(item =>
      !item.Reviewed &&
      [EExceptionType.BIOMETRIC, EExceptionType.LOCATION, EExceptionType.MICRO_LOCATION, EExceptionType.NO_DEVICE_LOCATION, EExceptionType.NO_LOCATION_OR_MICROLOCATION]
        .includes(item.TypeEnum)
    )
    firstBioAndLocException = exceptionPunchSet.PunchExceptions.find(item =>
      [EExceptionType.BIOMETRIC, EExceptionType.LOCATION, EExceptionType.MICRO_LOCATION, EExceptionType.NO_DEVICE_LOCATION, EExceptionType.NO_LOCATION_OR_MICROLOCATION]
        .includes(item.TypeEnum)
    )
  }
  else {
    const shiftExceptionDocument = props.exceptionItem as IShiftExceptionDocument
    shiftExceptionDocument.TypeEnum === EExceptionType.MISSING_IN_PUNCH &&
      exceptions.push(strings.Missing_In_Punch)
    shiftExceptionDocument.TypeEnum === EExceptionType.MISSING_BREAK &&
      exceptions.push(strings.Missing_Break)
  }

  return (
    <Chip
      labelStyle={{ fontSize: 12 }}
      backgroundColor={backgroundColor}
    >
      <div
        style={{ width: 60, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "white", fontWeight: 500 }}
        onClick={() => {
          unReviewedBioAndLocException ?
            props.handleShowExceptionDailog(unReviewedBioAndLocException.TypeEnum === EExceptionType.BIOMETRIC ? EExceptionReviewDialogExceptionType.Biometric : EExceptionReviewDialogExceptionType.Location, unReviewedBioAndLocException.PunchId) :
            firstBioAndLocException &&
            props.handleShowExceptionDailog(firstBioAndLocException.TypeEnum === EExceptionType.BIOMETRIC ? EExceptionReviewDialogExceptionType.Biometric : EExceptionReviewDialogExceptionType.Location, firstBioAndLocException.PunchId)
        }}
        title={exceptions.join(", ")}
      >
        {strings.Exceptions}F
      </div>
    </Chip >
  )
}

export default ExceptionsCol